import { render, staticRenderFns } from "./goodPrice.vue?vue&type=template&id=35e6218a&scoped=true"
import script from "./goodPrice.vue?vue&type=script&lang=js"
export * from "./goodPrice.vue?vue&type=script&lang=js"
import style0 from "./goodPrice.vue?vue&type=style&index=0&id=35e6218a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e6218a",
  null
  
)

export default component.exports